<template>
  <div v-if="!ISLOADING" :class="navBarUpdate">
    <nav :class="(routerName == 'AboutUs' || routerName == 'packageDetails' || routerName == 'detailsMaintenance') ? 'navbar  navbar-expand-lg bg-white pt-2 main-nav':'navbar navbar-expand-lg bg-white  pt-2 main-nav'">
      <NavBarItems />
    </nav>

    <!-- begin: navBar About Page -->
    <div class="row moreAbout" v-if="routerName == 'AboutUs'">
      <div class="col">
        <div>{{$t('about.Who_are_we')}}</div>
        <div class="aboutTeam">
          {{$t('about.aboutTeam')}}
        </div>
      </div>
    </div>
    <!-- end: navBar About Page -->

    <!-- begin: navBar Package Details -->
    <div class="row moreAbout" v-if="routerName == 'packageDetails'">
      <div class="col">
        <div class="row">
          <div class="col">
            <div>{{$t('package_Controlpanel')}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="font-30">
              {{$t('valuedPartner')}}
            </div>
          </div>
          <div class="col-2 content-center">
            <span>{{$t('renewal')}}</span>
          </div>
          <div class="col-auto Inactive content-center">
            <span class="circle"></span>
            <span class="mx-2">{{$t('Inactive')}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- end: navBar Package Details -->

    <!-- begin: navBar ProfilePage -->
    <div class="row moreAbout" v-if="routerName == 'ProfilePage' || routerName == 'AccountType' ">
      <div class="col">
        <div class="row">
          <div class="col">
            <div>{{$t('myAccount')}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="font-30">
              {{$t('myPersonal')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end: navBar ProfilePage -->
    
    <!-- begin: navBar details Maintenance -->
    <!-- <div class="row moreAbout" v-if="routerName == 'detailsMaintenance'">
      <div class="col">
        <div class="row">
          <div class="col">
            <div>{{$t('maintenance_Followup')}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="font-30">
              {{$t('valuedPartner')}}
            </div>
          </div>
          <div class="col-2 content-center">
            <span>{{$t('renewal')}}</span>
          </div>
          <div class="col-auto active_system content-center">
            <span class="circle"></span>
            <span class="mx-2">{{$t('maintenanceSystem')}}</span>
          </div>
        </div>
      </div>
    </div> -->
    <!-- end: navBar details Maintenance -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBarItems from "./navbar_items.vue";

export default {
  name: "NavBar",
  data(){
    return {
      routerName: "home",
      rows: [],
      isLoading: false,
      userLang: "ar",
      hasError: false,
      message: "",
      errorNumber: null,
      notificationsMap: {
        property: 'propertydetails',
        preview: 'previewdetails',
        reservation: 'propReservationDetails',
        manage_property_services: 'myrequests?dataType=propertyManagement',
        property_documented: 'myrequests',
        orders: 'maintenancedetails',
        photos: 'photographyDetails',
        finance: 'myrequests',
        lawyer_requests: 'lawyerRequestedDetails',
        exchange: 'businessTransfer',
        ownedProperty: 'rental'
      },
      chatTitle: '',
      errorMsg: '',
      chatError: false,
    }
  },

  components: {
    NavBarItems
  },

  computed: {
    ...mapGetters(["GET_USER", "GET_USER_DATA", "ISLOADING","GET_ROUTE",'BASE_URL', 'CHAT_CLIENT']),
    navBarUpdate(){
      return (
        // ['AboutUs','packageDetails','detailsMaintenance','ProfilePage'].includes(this.routerName)? 'bg-card-linear header-menu' : 'header-menu'
        !['home'].includes(this.routerName)? 'bg-card-linear header-menu' : 'header-menu'
      )
    }
  },

  methods: {
  },
  created(){
    this.userLang = localStorage.getItem('lang') ??  'ar';
  },
  watch: {
    $route(to, from) {
      // console.log('Route changed from', from.name, 'to', to.name)
      this.routerName = to.name;
      // console.log(this.routerName);
    },
  },

};
</script>
<style scoped>
  .nav-btn {
    background: none;
    border: none;
    width: 100%;
    padding: 0;
    text-align: start;
  }
  .modal-header .btn-close {
    margin-left: 0;
  }
  .myrequest .dropdown-item:hover {
    /* background-color: var(--bs-dropdown-link-hover-bg); */
    background-color: #fff !important;
  }
</style>
